import { Grid, GridProps, MantineSize } from "@mantine/core"
import React, { ReactNode } from "react"

type EqualWidthGridProps = {
  children: ReactNode
  spacing?: string | MantineSize
  blockAlign?: "center" | "flex-start" | "flex-end"
  preventWrap?: boolean
} & GridProps

export const EqualWidthGrid = ({
  children,
  spacing = "xs",
  preventWrap = true,
  blockAlign = "center",

  ...props
}: EqualWidthGridProps) => {
  const childCount = React.Children.count(children)
  const columnSpan = childCount > 0 ? 12 / childCount : 12
  const typeSafeChildren: ReactNode[] = React.Children.toArray(children)

  return (
    <Grid
      gutter={spacing}
      w="100%"
      grow={!preventWrap}
      styles={{
        inner: {
          alignItems: blockAlign,
        },
      }}
      {...props}
    >
      {React.Children.map(typeSafeChildren, (child) => (
        <Grid.Col
          span={columnSpan}
          style={{
            minWidth: preventWrap ? `${100 / childCount}%` : "auto",
            flexShrink: preventWrap ? 0 : 1,
          }}
        >
          {child}
        </Grid.Col>
      ))}
    </Grid>
  )
}
